import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69e20d9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "privacy-policy" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Terms of Use (EULA) for OfficeTime", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Лицензионное соглашение с конечным пользователем (EULA) для приложения OfficeTime", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { key: 1 }

import { reactive, onBeforeMount } from 'vue'

interface InfoBlock {
    heading: string;
    content: string | string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EulaView',
  setup(__props) {

const state = reactive({
  policy: [] as InfoBlock[],
  eulaRu: [] as InfoBlock[]
})

onBeforeMount(() => {
  state.policy = [
    {
      heading: 'IMPORTANT — PLEASE READ CAREFULLY',
      content: [
        'This End User License Agreement ("Agreement") is a legal agreement between you ("User" or "You") and LLC "Yaros Group" ("Company", "we", "us", or "our") regarding the use of the OfficeTime mobile application ("Software" or "App").',
        'By downloading, installing, or using the App, you agree to be bound by the terms of this Agreement.'
      ]
    },
    {
      heading: '1. LICENSE GRANT',
      content: 'We grant you a non-exclusive, non-transferable, revocable license to use the App for personal or business purposes on Apple-branded devices that you own or control, as permitted by the App Store Terms of Service.'
    },
    {
      heading: '2. RESTRICTIONS',
      content: [
        'You may not:',
        '•  copy, modify, reverse engineer, or decompile the App;',
        '•  rent, sublicense, distribute, or transfer the App;',
        '•  use the App for unlawful purposes;',
        '•  use the App in a way that violates the privacy or data protection rights of others.'
      ]
    },
    {
      heading: '3. DESCRIPTION OF SERVICES',
      content: [
        'OfficeTime is a smart employee time-tracking system based on facial recognition. Features include:',
        '•  capturing photos of employees during check-in and check-out;',
        '•  logging start and end times of the workday;',
        '•  automated reporting and integration with 1C;',
        '•  sending notifications to Telegram with photos;',
        '•  flexible tracking of absences and work hours.'
      ]
    },
    {
      heading: '4. DATA PROCESSING AND PRIVACY',
      content: [
        'The App uses facial recognition technology solely for time tracking. No biometric data is stored or transmitted — only hash values generated locally on the device are used for secure comparison.',
        'The App does <b>not</b> collect or use geolocation data.',
        'Data is processed exclusively for work time tracking purposes and in accordance with our <a href="https://officetime.yaros.kg/#/privacy-policy" target="_blank" style="color:#fff;">Privacy Policy</a>. It is your responsibility to ensure that proper notice or consent is obtained from all employees, as required by applicable law.'
      ]
    },
    {
      heading: '5. INTELLECTUAL PROPERTY',
      content: 'All rights, title, and interest in and to the App, including copyrights, trademarks, and trade secrets, are owned by LLC "Yaros Group". You are granted only a limited license to use the App as described in this Agreement.'
    },
    {
      heading: '6. TERMINATION',
      content: 'This Agreement remains in effect until terminated. We may terminate your license at any time if you violate its terms. Upon termination, you must cease all use of the App and delete all copies from your devices.'
    },
    {
      heading: '7. DISCLAIMER OF WARRANTIES',
      content: 'The App is provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the App will function without interruption or errors.'
    },
    {
      heading: '8. LIMITATION OF LIABILITY',
      content: 'To the fullest extent permitted by applicable law, LLC "Yaros Group" shall not be liable for any indirect, incidental, special, or consequential damages arising out of or related to your use or inability to use the App.'
    },
    {
      heading: '9. GOVERNING LAW',
      content: 'This Agreement shall be governed by and construed in accordance with the laws of the Kyrgyz Republic, without regard to its conflict of law provisions.'
    },
    {
      heading: '10. THIRD-PARTY TERMS',
      content: 'This Agreement does not override the Apple Media Services Terms and Conditions. You must also comply with those terms when using the App.'
    },
    {
      heading: 'Contact Information',
      content: [
        'If you have any questions about this Agreement, please contact us at:',
        '<b>LLC "Yaros Group"</b>',
        '<b>Email:</b> support@yaros.kg',
        '<b>Website:</b> <a href="https://yaros.kg" target="_blank" style="color:#fff;">https://yaros.kg</a>'
      ]
    },
    {
      heading: '',
      content: '© 2021 LLC "Yaros Group". All rights reserved.'
    }
  ]
  state.eulaRu = [
    {
      heading: 'ВАЖНО — ВНИМАТЕЛЬНО ПРОЧИТАЙТЕ:',
      content: [
        'Настоящее Лицензионное соглашение с конечным пользователем ("Соглашение") является юридическим договором между вами ("Пользователь" или "Вы") и ОсОО "Ярос групп" ("Компания", "мы", "нас" или "наш") в отношении использования приложения OfficeTime ("Программное обеспечение" или "Приложение").',
        'Скачивая, устанавливая или используя Приложение, вы соглашаетесь с условиями настоящего Соглашения.'
      ]
    },
    {
      heading: '1. ПРЕДОСТАВЛЕНИЕ ЛИЦЕНЗИИ',
      content: 'Компания предоставляет вам неисключительное, непередаваемое, отзывное право использовать Приложение в личных или корпоративных целях на устройствах Apple, находящихся в вашей собственности или под вашим контролем, в соответствии с условиями использования App Store.'
    },
    {
      heading: '2. ОГРАНИЧЕНИЯ',
      content: [
        'Вы не имеете права:',
        '•  копировать, модифицировать, декомпилировать или производить обратную разработку Приложения;',
        '•  сдавать в аренду, передавать или сублицензировать Приложение;',
        '•  использовать Приложение в незаконных целях;',
        '•  использовать Приложение для нарушения прав на конфиденциальность или защиту данных других лиц.'
      ]
    },
    {
      heading: '3. ОПИСАНИЕ ФУНКЦИОНАЛА',
      content: [
        'OfficeTime — это система автоматизированного учёта рабочего времени с использованием технологии распознавания лиц. Возможности включают:',
        '•  фотографирование сотрудников при приходе и уходе;',
        '•  фиксацию времени начала и окончания рабочего дня;',
        '•  автоматическое формирование отчётов и интеграцию с 1С;',
        '•  отправку уведомлений в Telegram с фотографиями;',
        '•  гибкие настройки учёта отсутствий и рабочего времени.'
      ]
    },
    {
      heading: '4. ОБРАБОТКА ДАННЫХ И КОНФИДЕНЦИАЛЬНОСТЬ',
      content: [
        'Приложение использует технологию распознавания лиц для фиксации прихода и ухода сотрудников. Биометрические данные не сохраняются и не передаются — используется безопасное сопоставление хеш-сумм, полученных на устройстве.',
        'Приложение не запрашивает и не использует данные геолокации.',
        'Обработка данных осуществляется строго в рамках целей учёта рабочего времени и в соответствии с нашей <a href="https://officetime.yaros.kg/#/privacy-policy" target="_blank" style="color:#fff;">Политикой конфиденциальности</a>. Вы обязаны обеспечить наличие соответствующего уведомления и (при необходимости) согласия со стороны сотрудников в соответствии с применимым законодательством.'
      ]
    },
    {
      heading: '5. ПРАВА ИНТЕЛЛЕКТУАЛЬНОЙ СОБСТВЕННОСТИ',
      content: 'Все права на Приложение, включая авторские права, товарные знаки и ноу-хау, принадлежат ОсОО "Ярос групп". Вы получаете только ограниченную лицензию на использование, как указано в настоящем Соглашении.'
    },
    {
      heading: '6. ПРЕКРАЩЕНИЕ ДЕЙСТВИЯ',
      content: 'Данное Соглашение действует до момента его прекращения. Компания может прекратить действие лицензии в любое время в случае нарушения вами условий Соглашения. После прекращения действия вы обязаны прекратить использование Приложения и удалить все его копии.'
    },
    {
      heading: '7. ОТКАЗ ОТ ГАРАНТИЙ',
      content: 'Приложение предоставляется "как есть" и "по доступности", без каких-либо явных или подразумеваемых гарантий. Мы не гарантируем, что работа Приложения будет бесперебойной или безошибочной.'
    },
    {
      heading: '8. ОГРАНИЧЕНИЕ ОТВЕТСТВЕННОСТИ',
      content: 'В максимально допустимой законом степени Компания не несёт ответственности за какие-либо косвенные, случайные, специальные или последующие убытки, возникшие в результате использования или невозможности использования Приложения.'
    },
    {
      heading: '9. ПРИМЕНИМОЕ ПРАВО',
      content: 'Настоящее Соглашение регулируется законодательством Кыргызской Республики без учёта коллизионных норм.'
    },
    {
      heading: '10. СТОРОННИЕ УСЛОВИЯ',
      content: 'Настоящее Соглашение не заменяет собой Условия использования медиасервисов Apple. Вы также обязаны соблюдать их при использовании Приложения.'
    },
    {
      heading: 'Контакты',
      content: [
        'Если у вас есть вопросы относительно настоящего Соглашения, свяжитесь с нами:',
        '<b>ОсОО "Ярос групп"</b>',
        '<b>Email:</b> support@yaros.kg',
        '<b>Веб-сайт:</b> <a href="https://yaros.kg" target="_blank" style="color:#fff;">https://yaros.kg</a>'
      ]
    },
    {
      heading: '',
      content: '© 2021 ОсОО "Ярос групп". Все права защищены.'
    }
  ]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.policy, (section, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "info-block"
        }, [
          _createElementVNode("h2", null, _toDisplayString(section.heading), 1),
          (Array.isArray(section.content))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.content, (line, i) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: i,
                    innerHTML: line
                  }, null, 8, _hoisted_5))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(section.content), 1))
        ]))
      }), 128)),
      _hoisted_7,
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.eulaRu, (section, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "info-block"
        }, [
          _createElementVNode("h2", null, _toDisplayString(section.heading), 1),
          (Array.isArray(section.content))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.content, (line, i) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: i,
                    innerHTML: line
                  }, null, 8, _hoisted_10))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(section.content), 1))
        ]))
      }), 128))
    ])
  ]))
}
}

})